import DashboardCTA from './DashboardCTA';
import RecommendedCommunities from './RecommendedCommunities';

function Dashboard() {
  return (
    <>
      <DashboardCTA />

      <div className="mt-6">
        <RecommendedCommunities />
      </div>
    </>
  );
}

export default Dashboard;
